import { render, staticRenderFns } from "./WizardForm.vue?vue&type=template&id=6757a695"
import script from "./WizardForm.vue?vue&type=script&lang=js"
export * from "./WizardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports